import React from 'react';
import TimelineItemWithArrow from './TimelineItemWithArrow';

const HistoryWithArrow = ({ events, onItemClick }) => (
  <div className="timeline" style={{ maxHeight: '450px', overflowY: 'auto' }}>
    {events.map(event => (
      <TimelineItemWithArrow key={event.id} event={event} onClick={onItemClick} />
    ))}
  </div>
);

export default HistoryWithArrow;
